import Vue from 'vue';
const $t = (() => {
    let vm;
    function $t(str) {
        let globalI18n = window["globalI18n"];
        if (!vm) {
            vm = new Vue({
                i18n: globalI18n,
                render: h => h('div'),
            });
        }
        if (vm.$t) {
            return vm.$t(str);
        }
        else {
            return str;
        }
    }
    return $t;
})();
const $t2 = (() => {
    function $t(str) {
        let globalI18n = window["globalI18n"];
        str = str.replace('cloudpivot.all.', '');
        return globalI18n.messages[globalI18n.locale].cloudpivot.all[str];
    }
    return $t;
})();
export default $t;
export { $t, $t2 };
